import { render, staticRenderFns } from "./courseRanking.vue?vue&type=template&id=40b7f47d"
import script from "./courseRanking.vue?vue&type=script&lang=js"
export * from "./courseRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports